module.exports = __webpack_public_path__ + "static/media/trombone-langdon-street.f61cd40a.jpg";